import { ANIMATED_WEATHER_ICONS } from "@Constants/localStorage";
import { useLocalStorage } from "usehooks-ts";

type UseAnimatedWeatherIcons = {
  enabled: boolean;
  setEnabled: (enabled: boolean) => void;
  reset: () => void;
};

export const useAnimatedWeatherIcons = (): UseAnimatedWeatherIcons => {
  const [value, setValue, removeValue] = useLocalStorage<boolean>(
    ANIMATED_WEATHER_ICONS,
    false, // Default is disabled
  );

  return {
    enabled: value,
    setEnabled: setValue,
    reset: removeValue,
  };
};
